module.exports = __webpack_public_path__ + "static/img/Ok300_300.b441f5bd.png";